module.exports = __webpack_public_path__ + "static/media/dual_yield.d7e31946.png";